import { BuyPlan } from '@buy/state/plan'
import { priceInitialData } from './price'

export const planInitialData: BuyPlan = {
    name: '',
    shortName: '',
    groupKey: '',
    description: '',
    addons: [],
    pricingInfo: priceInitialData,
    paymentPlans: [],
    productSku: '',
    purchaseOption: '',
    sKU: '',
    quantityErrorMessage: '',
    planKey: '',
    activeCoupon: null,
    endpointsIncludedText: null,
    endpointsIncludedAmount: 0,
    userAgentsIncludedText: null,
    userAgentsIncludedAmount: 0,
    shortDescription: '',
    userAgentsTootip: '',
    endpointsTooltip: '',
    highlightsLabel: '',
    highlightSelection: [],
    sKUSelectors: [],
    billingPeriods: [],
}
